// pages/admin/payroll/RunPayroll.jsx

import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";

import RegularPayroll from "./RegularPayroll";
import TerminationPayroll from "./TerminationPayroll";
import OneTimePayroll from "./OneTimePayroll";
import PayrollHistory from "./PayrollHistory";

import { Calendar, UserX, Gift, History } from "lucide-react";

const RunPayroll = () => {
  const [payrollType, setPayrollType] = useState("regular");

  return (
    <div className="space-y-6 min-h-screen">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Run Payroll
        </h1>
        <p className="text-muted-foreground mt-1">
          Process salaries, settlements, and special payouts
        </p>
      </div>

      {/* Payroll Type Switch */}
          <Tabs value={payrollType} onValueChange={setPayrollType}>
            <TabsList className="flex justify-start space-x-8 overflow-x-auto bg-transparent h-auto p-0 no-scrollbar">
              <TabsTrigger className="bg-transparent" value="regular">
                <Calendar className="w-4 h-4 mr-2" />
                Regular Payroll
              </TabsTrigger>

              <TabsTrigger value="termination">
                <UserX className="w-4 h-4 mr-2" />
                Termination
              </TabsTrigger>

              <TabsTrigger value="one_time">
                <Gift className="w-4 h-4 mr-2" />
                One-Time
              </TabsTrigger> 

              <TabsTrigger value="history">
                <History className="w-4 h-4 mr-2" />
                History
              </TabsTrigger>
            </TabsList>
          </Tabs>

      {/* Payroll Content */}
      {payrollType === "regular" && <RegularPayroll />}
      {payrollType === "termination" && <TerminationPayroll />}
      {payrollType === "one_time" && <OneTimePayroll />}
      {payrollType === "history" && <PayrollHistory />}
    </div>
  );
};

export default RunPayroll;
